import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Table helpers shared across the routed hierarchy pages (grades, tracks,
 * lessons, clips, templates, assessments). Extracted from the old
 * ContentTreeScreen so every page renders the same "edit + delete" actions
 * column, the same clickable-row style, and the same empty-state CTA.
 */
import React from 'react';
import { Button, Empty, Popconfirm, Space } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
/**
 * Standard row-actions column: edit pencil (optional) + delete trash. Every
 * table in the admin uses this so the affordances are visually identical.
 * `onEdit`/`onDelete` stop click propagation so they never trigger the
 * row-navigation handler that sits on the whole row.
 */
export function actionsCol(onEdit, onDelete, label = 'למחוק?') {
    return {
        title: 'פעולות', key: '__actions', width: 130, fixed: 'right',
        render: (_, row) => (_jsxs(Space, { size: 4, children: [onEdit && (_jsx(Button, { size: "small", icon: _jsx(EditOutlined, {}), onClick: (e) => { e.stopPropagation(); onEdit(row); } })), _jsx(Popconfirm, { title: label, okText: "\u05DE\u05D7\u05E7", cancelText: "\u05D1\u05D8\u05DC", onConfirm: () => onDelete(row), children: _jsx(Button, { size: "small", danger: true, icon: _jsx(DeleteOutlined, {}), onClick: (e) => e.stopPropagation() }) })] })),
    };
}
/**
 * Row-click helper for navigation-driven lists. Whole row is clickable and
 * routes to the entity's page. Highlighting an active row isn't needed here
 * (unlike the old master/detail flow) because navigation replaces the page.
 */
export function navRowProps(onSelect) {
    return (row) => ({
        onClick: () => onSelect(row),
        style: { cursor: 'pointer' },
    });
}
/**
 * Shared empty state with an optional "create" CTA. Same wording pattern
 * everywhere so a table with no rows always tells Sam what to do next.
 */
export function emptyState(text, cta) {
    return (_jsx(Empty, { description: text, image: Empty.PRESENTED_IMAGE_SIMPLE, children: cta && (_jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: cta.onClick, children: cta.label })) }));
}
